import { NavItem } from 'src/layouts/SidebarV2/primitives';
import type { NavItemModel } from 'src/layouts/SidebarV2/types';
import { cn } from 'src/utils/utils';

export interface PrimaryNavProps {
  items: NavItemModel[];
  collapsed?: boolean;
}

const PrimaryNav = ({ items, collapsed = false }: PrimaryNavProps) => {
  return (
    <nav
      className={cn(
        'tw:flex tw:flex-col tw:gap-3xs',
        collapsed ? 'tw:w-max' : 'tw:w-full'
      )}
    >
      {items.map((item) => (
        <NavItem
          key={item.id}
          name={item.name}
          icon={item.icon}
          badge={item.badge}
          endIcon={item.endIcon}
          endIconColorClass={item.endIconColorClass}
          to={item.to}
          onClick={item.onClick}
          collapsed={collapsed}
        />
      ))}
    </nav>
  );
};

export { PrimaryNav };
